/* eslint-disable max-len */
export const scheduledEmailSubject = 'Meeting Reminder: {{Topic_or_Presenter}}';
export const scheduledEmailBody = `<p>Dear {{First_Name}} {{Last_Name}},</p>
<p>This is a reminder that your meeting for {{Event_Name}} is coming up at {{Meeting_Start_Date_Time}}.</p>
<p><a href="{{Magic_Link}}" target="_blank">Click Here to sign in automatically</a></p>
<p>If the above link does not work, paste <a href="{{Event_URL}}" target="_blank">{{Event_URL}}</a> into your browser and sign in using the details below.</p>
<hr>
<p>Registration Details</p>
<p>Email Address: {{Email}}</p>
<p>Access Code: {{Access_Code}}</p>
<hr>
<p>Add to Calendar</p>
<p>To add this meeting to your calendar, please use the links below:</p>
<p><a href="{{Add_Meeting_to_Outlook}}" target="_blank">Add to Outlook calendar</a></p>
<p><a href="{{Add_Meeting_to_Google}}" target="_blank">Add to Google calendar</a></p></p>
<hr>
<p>Please do not reply to this email, as this inbox is not monitored. To report abuse, please forward this entire message to <a href=\"mailto:reportabuse@openexc.com\">reportabuse@openexc.com</a></p>`;